module.exports = __webpack_public_path__ + "static/media/chess-king-alt.da7b302b.svg";